<template>
	<el-dialog v-model="innerVisible" :title="title" width="50%" custom-class="zero-padding-modal" @open="openInit" @opened="openedInit" @closed="closeDeal">
		<el-form :model="addForm" label-width="130px" ref="dialogRef" :rules="formRules" style="margin: 20px;padding: 20px;">
			<el-row>
				<el-col :span="24">
					<el-form-item label="调拨单别:" prop="orderCategory">
						<el-select v-model="addForm.orderCategory" clearable allow-create filterable placeholder="请选择调拨单别" size="large" style="width: 100%;" :popper-append-to-body="false">
							<el-option v-for="item in CMSMQData" :key="item.label" :label="item.mQ002" :value="item.mQ001" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="部门编号:" prop="departmentNumber">
						<!-- <el-input v-model="query.departmentNumber" clearable placeholder="请输入部门编号" /> -->
						<el-select v-model="addForm.departmentNumber" clearable allow-create filterable placeholder="请选择部门编号" size="large" style="width: 100%;" :popper-append-to-body="false">
							<el-option v-for="item in departmentData" :key="item.label" :label="item.mE002" :value="item.mE001" />
						</el-select>
					</el-form-item>
				</el-col> 
				<el-col :span="24">
					<el-form-item label="项目编号:" prop="projectCode">
						<!-- <el-input v-model="addForm.projectCode" clearable placeholder="请输入项目编号" /> -->
						<el-select
							style="width: 100%;"
							v-model="addForm.projectCode"							
							filterable
							remote
							reserve-keyword
							placeholder="请输入项目编号"
							remote-show-suffix
							:remote-method="remoteMethod"
							:loading="loading"
						>
							<el-option
							v-for="(item,index) in options"
							:key="index"
							:label="item"
							:value="item"
							/>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="备注:" prop="remarks">
						<el-input v-model="addForm.remarks" clearable placeholder="请输入备注" />
					</el-form-item>
				</el-col>                                 
			</el-row>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary"  @click="onComfirm">查 询</el-button> 
				<!-- :disabled="list.length===0" -->
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, watch, toRefs,reactive  } from 'vue'	
import ChooseMaterialModal from './ChooseMaterialModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { AddTransferOrder, AddTransferOrderDetails,AddTransdepartment,GetCMSMQ,GetProjectCode } from '@/service/main/invoices/allocateOrder';
import { localStatus } from '../../switchCase'

const emits = defineEmits(['update:visible','loadInitData','callback'])

const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	type:{
		type:String,
		default:'info'
	},
	orderId:{
		type:[String,Number],
		default:''
	}
})
//////////////////////////////////
const formRules = {
    orderCategory: [{ required: true, message: "发货地不能为空", trigger: "blur" }],
    departmentNumber: [{ required: true, message: "收货地址不能为空", trigger: "blur" }],
    projectCode: [{ required: true, message: "预计到达日期不能为空", trigger: "blur" }],
    // remarks: [{ required: true, message: "发货日期不能为空", trigger: "blur" }],
}
// 编辑送货预约窗口中表单数据绑定
const addForm = reactive({
    id: 0,
	orderCategory:"",//单别
    departmentNumber: "",//部门编号
    projectCode: "",//项目编号
    remarks: "",
})
const departmentData = ref([])
const getStatusOption = function(){
	AddTransdepartment().then((d)=>{
		departmentData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOption()
const CMSMQData = ref([])
const getStatusOptions = function(){
	GetCMSMQ().then((d)=>{
		CMSMQData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOptions()
const { visible, type, orderId } = toRefs(props)

const innerVisible = ref(false)
const title = ref('单据调拨')
const chooseVisieble = ref(false)
const list = ref([])

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

//项目号模糊查询
const loading = ref(false)
const options = ref([])
const remoteMethod = function(query){
	options.value = []
	if (query!==null&&query!==undefined&&query.length>2) {
		loading.value = true	
		GetProjectCode({ProjectCode:query}).then((res) => {
			// console.log('res',res)
			loading.value = false
			options.value = res.data
		}).catch(()=>{
			loading.value = false
		})
	} else {
		options.value = []
	}
}

const closeDeal = function(){
	title.value = '调拨单'
	list.value = []
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
	addForm.orderCategory=""//单别
    addForm.departmentNumber= ""//部门编号
    addForm.projectCode= ""//项目编号
    addForm.remarks = ""
	options.value = []
}

const checkBeforeSubmit = function() {
	let n = -1
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].orderQuantity<=0) {
			n = i;
			break
		}
	} 
	if (n===-1) {
		return true
	} else {
		ElMessageBox.alert(`第${n+1}笔物料出库数错误。`,'系统提示')
		return false
	}
}
const dialogRef = ref()
const onComfirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
            let f = checkBeforeSubmit()
			if (!f) return flase
			confirmAjax((f)=>{
				if (f) {
					ElMessage.success("操作成功")
					selfClose()
					emits('callback')
				}
			})

        } 
    })
	
}

const openInit = function(){
	setTitle()
}

const openedInit = function(){
	if (type.value==='modify') {
		getModifyInitData()
		nextTick(() => {
			dialogRef.value.clearValidate()
		})
	}
}

const getModifyInitData = function(){
	emits('loadInitData',{id:orderId.value,PageNo:1,PageSize:9999},function(f,d){
		if (f) {
			list.value = (d.data.rows || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}

const setTitle = function(){
	if (type.value==='modify') {
		title.value = '修改调拨单'
	} else {
		title.value = '新增调拨单'
	}
}

const onOpenChooseModal = function(){
	chooseVisieble.value = true
}

const chooseModalCallback = function(arr){
	if (list.value.length===0) {
		list.value = arr.map((obj,index)=>{
			obj.tableKey = 'add-' + new Date().getTime() + '-' + index
			obj.orderQuantity = obj.currentQuantity
			return obj
		})
	} else {
		addChooseMaterials(arr)
	}
}

const addChooseMaterials = function(arr) {
	let c = 0
	arr.forEach((arritem,arri)=>{
		if (checkMaterialExist(arritem)) {
			c++
		} else {
			arritem.tableKey = 'add-' + new Date().getTime() + '-' + arri
			arritem.orderQuantity = arritem.currentQuantity
			list.value.push(arritem)
		}
	})
	
	if (c>0) {
		ElMessageBox.alert(`有${c}哥物料已存在，未加入。`,'系统提示')
	}
}

const checkMaterialExist = function(obj) {
	let res = false
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].code===obj.code && list.value[i].locationCode===obj.locationCode) {
			res = true
			break
		}
	}
	return res
}

const onDel = function(index) {
	list.value.splice(index,1)
}

const confirmAjax = function(callback){
	if (type.value==='modify') {
		modifyAjax(callback)
	} else {
		newAjax(callback)
	}
}

const newAjax = function(callback) {
	// let params = {
	// 	wareOrderDetailss:list.value,
	// 	orderCategory:"1203"
	// }
	// console.log('addForm.value',addForm)
	AddTransferOrder(addForm).then((res) => {
	  callback && callback(true)
	}).catch(()=>{
		callback && callback(false)
	})
}

const modifyAjax = function(callback) {
	let params = {
		wareOrderDetailss:list.value,
		id:orderId.value
	}
	AddTransferOrderDetails(params).then((res) => {
	  callback && callback(true)
	}).catch(()=>{
		callback && callback(false)
	})
}

</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 60vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 12px 16px;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>